<template>
    <div v-loading.fullscreen.lock="loading">
        <table-judges-search-bar-component
            @search="get_table_judges_index"
        ></table-judges-search-bar-component>
        <common-table-component
            details_auth="个人评审详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_table_judges"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_table_judges_index"
        ></common-page-component>
        <table-judges-edit-component
            :dialogFormVisible="fdialogFormVisible"
            :details_data="ftable_judges_details_data"
            @search="get_table_judges_index"
            @details_row="details_table_judges"
            @exitDialog="dialogExit"
        ></table-judges-edit-component>
    </div>
</template>

<script>
import { table_judges_index_request,table_judges_details_request } from '@/network/kpi/TableJudges.js'

import TableJudgesSearchBarComponent from '@/components/kpi/TableJudges/TableJudgesSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import TableJudgesEditComponent from '@/components/kpi/TableJudges/TableJudgesEditComponent'

export default {
    name: 'TableJudgesView',
    data() {
        return {
            fid: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                name: '',
                state: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'name',
                    label: '考核表名称',
                    minWidth: '300px',
                    show_overflow_tooltip: true
                },{
                    prop: 'state',
                    label: '状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'info',
                                filter_data: '未评'
                            }
                        } else if(d===1) {
                            return {
                                type: 'success',
                                filter_data: '已评'
                            }
                        }
                    }
                },{
                    prop: 'staff_name',
                    label: '被考核人',
                    minWidth: '100px'
                },{
                    prop: 'sum_score',
                    label: '总分',
                    minWidth: '100px'
                }
            ],
            ftable_judges_details_data: {}
        }
    },
    computed: {},
    methods: {
        get_table_judges_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.state = param.state ?? this.cond.state
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            table_judges_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_table_judges(id) {
            this.fdialogFormVisible = true
            table_judges_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.ftable_judges_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
        }
    },
    filters: {},
    props: {},
    created() {
        this.get_table_judges_index()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        TableJudgesSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        TableJudgesEditComponent
    },
    watch: {},
}
</script>

<style lang='less'></style>